import { Helmet } from 'react-helmet-async'

const PageMeta = ({ 
  title = 'Web Design Centurion | RDS Studio — WordPress, SEO & Digital Marketing',
  description = 'Top-rated web design agency in Centurion. Custom WordPress sites from R8,500, local SEO & Google Ads. Serving Centurion, Pretoria & Gauteng for 10+ years. Free quote.',
  canonical = 'https://rdsstudio.co.za',
  ogImage = 'https://rdsstudio.co.za/images/logo/og-image.png'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      
      {/* Hreflang tags - Self-referencing for South African English */}
      <link rel="alternate" hrefLang="en-ZA" href={canonical} />
      <link rel="alternate" hrefLang="en" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />
      
      {/* Language and Region */}
      <meta httpEquiv="content-language" content="en-ZA" />
      
      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="RDS Studio" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_ZA" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@rdsstudio" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  )
}

export default PageMeta
